import { Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { SatPopover } from '@ncstate/sat-popover';
import PlaceResult = google.maps.places.PlaceResult;

import { SearchQuery } from '../models/search-query.model';
import { State } from '../../shared/state-view/state.model';
import { ACTIVITY_FILTERS, ActivityType } from '../filters/activity-filters';


@Component({
  selector: 'app-activity-results-listing',
  templateUrl: './activity-results-listing.component.html',
  styleUrls: ['./activity-results-listing.component.scss']
})
export class ActivityResultsListingComponent {
  @Input() query: SearchQuery;
  @Input() activities: Array<PlaceResult> = [];
  @Input() state: State = State.Empty;
  @Input() activeActivity: PlaceResult;
  @Input() errorMessage: string;
  @Output() selectedActivityChange = new EventEmitter<ActivityType>();
  @Output() activityMouseEnter = new EventEmitter<PlaceResult>();
  @Output() activityMouseLeave = new EventEmitter<PlaceResult>();

  @ViewChild('listEl') listEl: ElementRef;
  @ViewChildren('activityEl', { read: ElementRef }) activityEls: QueryList<ElementRef>;
  @ViewChild('activityFiltersPopover') activityFiltersPopover: SatPopover;

  get activityLabel(): string {
    if (!this.query.activity) {
      return '';
    }
    const f = ACTIVITY_FILTERS.get(this.query.activity);
    return f ? f.label : '';
  }

  onActivityHover(activity: PlaceResult, hover: boolean) {
    if (hover) {
      this.activityMouseEnter.emit(activity);
    } else {
      this.activityMouseLeave.emit(activity);
    }
  }

  /**
   * Returns a jQuery element container for the given activity.
   */
  getActivityEl(activity: PlaceResult) {
    const i = this.activities.indexOf(activity);
    if (i < 0) {
      return null;
    }
    const el = this.activityEls.toArray()[i];
    return $(el.nativeElement);
  }

  /**
   * Scrolls the activities list to the specified activity, marking it as selected.
   */
  public scrollToActivity(activity: PlaceResult) {
    if (!this.listEl) {
      return;
    }
    const $containerEl = $(this.listEl.nativeElement);
    const $el = this.getActivityEl(activity);
    if (!$el) {
      return;
    }
    const position = $el[0].offsetTop;
    $containerEl.stop(true);
    $containerEl.animate({ scrollTop: position }, 500);
  }

  onSelectedActivityChange(activityType: ActivityType) {
    this.selectedActivityChange.emit(activityType);
  }
}
